/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.15.0
 */

import { Step } from 'react-joyride';

export enum EOnboardingStatus {
    init = 'init',
    pageReady = 'pageReady',
    start = 'start',
    finish = 'finish',
}

export enum EOnboardingPage {
    accounts = 'accounts',
    dashboard = 'dashboard',
    expensesAnalyzerAccount = 'expensesAnalyzerAccount',
    products = 'products',
    inquiries = 'inquiries',
    settings = 'settings',
    subscriberMobile = 'subscriberMobile',
    bills = 'bills',
}

export enum EOnboardingComponentsId {
    // Хедер
    notificationsMenu = 'notificationsMenu', // Меню уведомлений

    // Верхнее меню
    linkAccounts = 'linkAccounts', // Ссылка Лицевые счета
    linkProducts = 'linkProducts', // Ссылка Тарифы и услуги
    linkHistoryAndOrders = 'linkHistoryAndOrders', // Ссылка Заказы и обращения
    linkSubscribers = 'linkSubscribers', // Ссылка Мобильная связь

    // главная страница
    widgetCost = 'widgetCost', // Виджет Расходы
    widgetPersonalAccount = 'widgetPersonalAccount', // Виджет Баланс лицевого счёта
    widgetSearchAccounts = 'widgetSearchAccounts', // Селектор поиска ЛС
    widgetSubscriberMaxCosts = 'widgetSubscriberMaxCosts', // Виджет Абоненты с наибольшими расходами
    fastActionsPlate = 'fastActionsPlate', // кнопки быстрых действий

    // список ЛС
    accountsTableFooterButtonBills = 'accountsTableFooterButtonBills', // Получить документы
    accountsTableFooterButtonDcRules = 'accountsTableFooterButtonDcRules', // Разделение расходов
    accountsTableFooterButtonExpenses = 'accountsTableFooterButtonExpenses', // Просмотреть расходы
    accountsTableFooterButtonReconciliation = 'accountsTableFooterButtonReconciliation', // Заказать акт сверки
    accountsTableFooterButtonReports = 'accountsTableFooterButtonReports', // Сформировать отчёт
    accountsTableSettings = 'accountsTableSettings', // Настройка столбцов

    // Анализатор ЛС
    expensesAnalyzerAccountChart = 'expensesAnalyzerAccountChart', // График расходов
    expensesAnalyzerAccountChartTab = 'expensesAnalyzerAccountChartTab', // По категориям/Динамика
    expensesAnalyzerAccountTable = 'expensesAnalyzerAccountTable', // Таблица расходов ЛС
    expensesAnalyzerAccountTableFooterButtonCallDetails = 'expensesAnalyzerAccountTableFooterButtonCallDetails', // Заказать детализацию
    expensesAnalyzerAccountTableFooterButtonShowDailyExpenses = 'expensesAnalyzerAccountTableFooterButtonShowDailyExpenses', // Расходы по дням
    expensesAnalyzerAccountTableFooterButtonShowSubsExpenses = 'expensesAnalyzerAccountTableFooterButtonShowSubsExpenses', // Расходы абонентов
    expensesAnalyzerAccountTableFooterButtonWizardExpensesDetail = 'expensesAnalyzerAccountTableFooterButtonWizardExpensesDetail', // Расходы корп клиента

    // список МС
    subscriberTable = 'subscriberTable', // Настройка столбцов
    subscriberTableFooterButtonAccessLevel = 'subscriberTableFooterButtonAccessLevel', // Уровень доступа
    subscriberTableFooterButtonAdditionalAccount = 'subscriberTableFooterButtonAdditionalAccount', // Упр. доп. счетами
    subscriberTableFooterButtonCallDetails = 'subscriberTableFooterButtonCallDetails', // Заказать детализацию
    subscriberTableFooterButtonCorporate = 'subscriberTableFooterButtonCorporate', // Услуги и опции
    subscriberTableFooterButtonExpenses = 'subscriberTableFooterButtonExpenses', // Просмотреть расходы
    subscriberTableFooterButtonInquiryCreate = 'subscriberTableFooterButtonInquiryCreate', // Создать обращение
    subscriberTableFooterButtonLabelEdit = 'subscriberTableFooterButtonLabelEdit', // Изменить метки
    subscriberTableFooterButtonLimit = 'subscriberTableFooterButtonLimit', // Настроить лимиты
    subscriberTableFooterButtonManageBlock = 'subscriberTableFooterButtonManageBlock', // Управлять блокировкой
    subscriberTableFooterButtonReports = 'subscriberTableFooterButtonReports', // Сформировать отчёт
    subscriberTableFooterButtonTariffChange = 'subscriberTableFooterButtonTariffChange', // Изменить тариф
    subscriberTablePersonalImport = 'subscriberTablePersonalImport', // Импорт перс. данных
    subscriberTableSettings = 'subscriberTableSettings', // Настройка столбцов
    subscribersInRoaming = 'subscribersInRoaming', //плашка "Абоненты в роуминге"

    // Тарифы и услуги
    productBtnConnect = 'productBtnConnect',
    productCardMooreDetailsLink = 'productCardMooreDetailsLink',
    productCardList = 'productCardList',
    productCategories = 'productCategories',
    productFilterRegion = 'productFilterRegion',
    productTabSelected = 'productTabSelected',

    // Настройки
    settingsTabLabels = 'settingsTabLabels',
    settingsTabPositions = 'settingsTabPositions',
    settingsTabProfile = 'settingsTabProfile',
    settingsTabNotifications = 'settingsTabNotifications',

    // Счета
    billsTable = 'billsTable',
    billsDescription = 'billsDescription',
    billsTableFooterButtonBillsDoc = 'billsTableFooterButtonBillsDoc',
    billsTableFooterButtonCompare = 'billsTableFooterButtonCompare',
    billsTableFooterButtonReconciliation = 'billsTableFooterButtonReconciliation',

    // Обращения
    inquiriesTabMenu = 'inquiriesTabMenu',
}

export enum EOnboardingModalId {
    modalWelcome = 'welcome',
    modalFinal = 'final',
}

export interface IOnboardingStep extends Step {
    page: {
        next: string;
    };
    link: {
        label: string;
        url: string;
    };
    stepId: EOnboardingComponentsId;
    text: string;
}
